import React from "react";
import { Message, Placeholder } from "semantic-ui-react";
import { useFileUrl } from "../context/FileUploadContext";
import _truncate from "lodash/truncate";

interface FileViewProps {
    id: string;
    title: string;
    truncateLength?: number
}


export const FileView: React.FC<FileViewProps> = ({ id, title, truncateLength = 40 }) => {
    const { loadError, fileUrl } = useFileUrl(id);

    let shortTitle = truncateLength > 0 ? _truncate(title, { length: 40 }) : title;

    if (fileUrl) {
        return <a href={fileUrl} title={title}> {shortTitle} </a>;
    }

    if (loadError) {
        return <Message negative compact>Tiedoston lataus ei onnistunut</Message>;
    }

    return <Placeholder> <Placeholder.Line /> </Placeholder>;

};
